import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";

// Material UI
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

// Components
import Loader from "../../components/Loader";
import TabPanel from "../../components/TabPanel";
import CompanyInfo from "./components/CompanyInfo";
import CompanyEdit from "./CompanyEdit";

// Actions
import { getCompaniesData } from "../../store/actions/companiesActions";

// Services
import { ValidationService } from "../../js/validationService";
const validationService = new ValidationService();

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function CompanyItem() {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const companiesDataObj = useSelector(state => state.companies.companiesDataObj);
  const [value, setValue] = useState(0);
  const [currentCompanyData, setCurrentCompanyData] = useState({});
  const [companyItemIsLoading, setCompanyItemIsLoading] = useState(true);
  const [companyItemNotFound, setCompanyItemNotFound] = useState(false);
  const companyId = Number.parseInt(useParams().companyId);

  const handleChange = (event, newValue) => setValue(newValue);

  useEffect(() => {
    if (Object.keys(companiesDataObj).length) {
      const currentCompany = companiesDataObj?.data?.filter(company => company.id === companyId);

      currentCompany.length > 0 ? setCurrentCompanyData(currentCompany[0]) : setCompanyItemNotFound(true);
      setCompanyItemIsLoading(false);
    } else {
      !Object.keys(companiesDataObj).length && getCompaniesData(1, dispatch);
    }
  }, []);

  const handleClose = () => {
    const previousLocation = validationService.getPreviousHistoryLocationPathname(history.location.pathname)[0];

    history.push(`/${previousLocation}`);
  };

  return (
    <>
      {companyItemIsLoading ? (
        <Loader isSection={true} />
      ) : companyItemNotFound ? (
        "The current item didn't found"
      ) : (
        <div className={classes.root}>
          <AppBar position="static" color="default">
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
              aria-label="auto tabs"
            >
              <Tab label="Company info" />
              <Tab label="Edit company" />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            <CompanyInfo currentCompany={currentCompanyData} handleClose={handleClose} />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <CompanyEdit
              currentCompany={currentCompanyData}
              companiesDataObj={companiesDataObj}
              handleClose={handleClose}
              dispatch={dispatch}
            />
          </TabPanel>
        </div>
      )}
    </>
  );
}
